import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import CustomAddButton from '../../../../Components/custom_components/CustomAddButton/CustomAddButton';
import { useFormik } from 'formik';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import CustomBreadcrumbs from '../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { currentStatusOptions, statusOptions } from '../../../../utils/constants';
import { get_technology_with_pagination } from '../../../../config/Resource/technologyApis';
import CustomDatePicker from '../../../../Components/custom_components/CustomDatePicker/CustomDatePicker';
import dayjs from 'dayjs';
import './EquipmentSearchFilterStyle.css';

function EquipmentSearchFilter({ searchFilter, isAddPermission, tableTitle, isAddEdiModalOpen, handleAddEditModal, on_change_value, on_page_count_update }) {

    const [technologyListing, setTechnologyListing] = useState([]);

    // FOR GET TECHNOLOGIES FROM LIST
    useEffect(() => {
        const fetchTechnologies = async () => {
            try {
                const params = {
                    status: 1 //1MEANS ACTIVE 
                }

                const response = await get_technology_with_pagination(params);
                if (response?.status === "success") {
                    // Transform data into the desired format with label and value
                    const transformedData = response.data.data?.map((item) => ({
                        label: item?.TechnologiesName,
                        value: item?.TechnologiesTypeId
                    }));

                    // Set the transformed data to the state
                    setTechnologyListing(transformedData || []);
                } else {
                    setTechnologyListing([]);
                }
            } catch (error) {
                console.error('Error fetching technologies:', error);
                setTechnologyListing([]);
            }
        };

        fetchTechnologies();
    }, []);

    const formik = useFormik({
        initialValues: {
            status: '',
            EquipmentName: '',
            Equipment_code: '',
            EquipmentserialNo: '',
            Manufacture: '', start_date: "",
            end_date: "",
            Availability: '',
        },
        // onSubmit: (values) => {
        //     searchFilter(values)
        // },
    });

    const resetFilter = () => {

        on_change_value(1)
        on_page_count_update(25)

        formik.resetForm();
        searchFilter({
            status: '',
            EquipmentName: '',
            Equipment_code: '',
            EquipmentserialNo: '',
            Manufacture: '',
            start_date: "",
            end_date: "",
            Availability: '',
        })
    };

    const handleNavigate = () => {
        handleAddEditModal(!isAddEdiModalOpen);
    };

    const breadcrumbs = ['Resources', tableTitle]

    return (
        <div className="equipment-search-filter-container">
            <div className="equipment-search-filter-sub-container">
                <div className="equipment-search-filter-header">
                    <div className="equipment-search-filter-left">
                        <div className="equipment-table-title">{tableTitle}</div>
                        <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                    </div>
                    <div className="equipment-search-filter-right">
                        {isAddPermission && <CustomAddButton label="Add" onClick={handleNavigate} />}
                    </div>
                </div>
                <div className="search-layout-wrapper">
                    <div className="search-filter-container">
                        <div className="search-inputs-fields">
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    id="EquipmentName"
                                    name="EquipmentName"
                                    placeholder="Search by Name"
                                    value={formik.values.EquipmentName}
                                    onChange={formik.handleChange}
                                    width='200px'
                                />
                            </Grid>


                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    id="Equipment_code"
                                    name="Equipment_code"
                                    placeholder="Search by Code"
                                    value={formik.values.Equipment_code}
                                    onChange={formik.handleChange}
                                    width='200px'
                                />
                            </Grid>


                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    id="EquipmentserialNo"
                                    name="EquipmentserialNo"
                                    placeholder="Search by Serial No"
                                    value={formik.values.EquipmentserialNo}
                                    onChange={formik.handleChange}
                                    width='200px'
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    id="Manufacture"
                                    name="Manufacture"
                                    placeholder="Search Manufacture"
                                    value={formik.values.Manufacture}
                                    onChange={formik.handleChange}
                                    width='200px'
                                />
                            </Grid>


                            <Grid item xs={12} sm={6} md={2}>

                                <CustomSelectDropdown
                                    name="staTechnologyIdtus"
                                    placeholder="Select Technology"
                                    options={technologyListing}
                                    value={technologyListing?.find(option => option?.value === formik?.values?.TechnologyId) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("TechnologyId", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    isDisabled={false}
                                    isMulti={false} // Set to false for single-select
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>

                                <CustomSelectDropdown
                                    name="Availability"
                                    placeholder="Filter by Availability"
                                    options={currentStatusOptions}
                                    value={currentStatusOptions?.find(option => option?.value === formik?.values?.Availability) ||
                                        currentStatusOptions?.find(option => option?.value === '')
                                    }
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("Availability", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    isDisabled={false}
                                    isMulti={false} // Set to false for single-select
                                    width="200px"
                                />

                            </Grid>


                            <Grid item xs={12} sm={6} md={2}>

                                <CustomSelectDropdown
                                    name="status"
                                    placeholder="Select Status"
                                    options={statusOptions}
                                    value={statusOptions?.find(option => option?.value === formik?.values?.status) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("status", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    isDisabled={false}
                                    isMulti={false} // Set to false for single-select
                                    width="150px"
                                />

                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomDatePicker
                                    name="start_date"
                                    label="From Date"
                                    onChange={(date) => {
                                        formik.setFieldValue("start_date", date);
                                    }}
                                    onBlur={formik.handleBlur}
                                    value={dayjs(formik.values.start_date, "DD-MM-YYYY")}
                                    width="170px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomDatePicker
                                    name="end_date"
                                    label="End Date"
                                    onChange={(date) => {
                                        formik.setFieldValue("end_date", date);
                                    }}
                                    onBlur={formik.handleBlur}
                                    value={dayjs(formik.values.end_date, "DD-MM-YYYY")}
                                    minDate={dayjs(formik.values.start_date, "DD-MM-YYYY")} // Set minimum date
                                    width="170px"
                                />
                            </Grid>
                        </div>
                        {/* Search Button */}
                        <div className="search-buttons-fixed-right">
                            <ActionButton
                                // onClick={formik.handleSubmit}
                                onClick={() => {
                                    on_change_value(1)
                                    searchFilter({ ...formik.values }); // Always trigger search, even if no values changed
                                }}
                                btnDisable={false}
                                label="Search"
                                btnType="primary"
                            />
                            <ActionButton label="Reset" btnType="outlined" onClick={resetFilter} />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default EquipmentSearchFilter;
